const carouselItems = [
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20coral%20tones%20trending%20topic%20visualization%20dynamic%20flowing%20shapes%20modern%20minimalist%20digital%20art%20soft%20gradient%20clean%20aesthetic&width=800&height=500&seq=mrds-carousel-01&orientation=landscape",
    tag: "本周最热",
    title: "七月娱乐圈大事件盘点：谁的瓜最甜？",
    desc: "从恋情曝光到综艺翻车，本月mrds热门话题一次性汇总，看看你错过了哪些精彩。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20amber%20gold%20warm%20tones%20entertainment%20news%20concept%20flowing%20ribbon%20shapes%20modern%20minimalist%20clean%20design%20soft%20gradient&width=800&height=500&seq=mrds-carousel-02&orientation=landscape",
    tag: "深度爆料",
    title: "独家深扒：最新黑料背后的惊人真相",
    desc: "mrds每日爆料独家追踪，层层揭开被掩盖的事实，带你看到表象之下的暗涌。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20orange%20peach%20tones%20comedy%20humor%20concept%20playful%20shapes%20floating%20elements%20modern%20minimalist%20digital%20art%20clean%20aesthetic&width=800&height=500&seq=mrds-carousel-03&orientation=landscape",
    tag: "搞笑合集",
    title: "本周擦边搞笑名场面Top10：笑到头掉",
    desc: "网友投稿的擦边搞笑内容精选，每一帧都是快乐源泉，打工人的午休快乐水。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20terracotta%20tones%20ranking%20chart%20concept%20rising%20arrows%20dynamic%20shapes%20modern%20minimalist%20clean%20design%20digital%20art&width=800&height=500&seq=mrds-carousel-04&orientation=landscape",
    tag: "榜单揭晓",
    title: "mrds八月第一周：新瓜榜单完整揭晓",
    desc: "大赛每日更新榜单看点，看看本周排名变化，谁能登顶最受关注话题榜首？",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20coral%20and%20rose%20tones%20social%20media%20trends%20concept%20floating%20icons%20speech%20bubbles%20modern%20minimalist%20digital%20art%20clean&width=800&height=500&seq=mrds-carousel-05&orientation=landscape",
    tag: "话题追踪",
    title: "热搜背后的故事：那些被忽略的细节",
    desc: "每个mrds热门话题背后都有一段不为人知的故事，我们为你还原完整时间线。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20gold%20amber%20tones%20community%20discussion%20concept%20connected%20circles%20network%20shapes%20modern%20minimalist%20clean%20design%20digital%20art&width=800&height=500&seq=mrds-carousel-06&orientation=landscape",
    tag: "读者精选",
    title: "本月最受欢迎爆料：读者票选TOP6出炉",
    desc: "来自mrds读者群体的真实投票，看看大家最关心的话题和爆料都有哪些。",
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            焦点专题
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200/70 px-3 py-1 rounded-full whitespace-nowrap">
            共6个专题
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <a key={i} href="#about" className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-background-50 transition-colors duration-200 cursor-pointer">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}